/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from "react";
import MapBase from "./MapBase";
import { PALETTE_YlOrRd_9, TRANSPARENT_COLOR } from "../../utils/Palette";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {
  arrayToRgb,
  getApiUrl,
  getLastYear,
  makeTableSorterFn,
  numberWithCommas,
} from "../../utils";
import WidgetClsCodeforStats from "./widgets/WidgetClsCodeForStats";
import RMateChartStatsAnalysis from "./r_mate_chart/RMateChartStatsAnalysis";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectMonthDetail from "./widgets/WidgetSelectMonthDetail";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import CenterIcon from "../../images/map-stats-analysis-icon.png";
import WidgetStatsAnalysisModal from "./widgets/WidgetStatsAnalysisModal";
import useStatsAnalysisSyncViewState from "./useStatsAnalysisSyncViewState";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetStatsAnalysisIndicator from "./widgets/WidgetStatsAnalysisIndicator";
import AlignRightText from "./widgets/AlignRightText";
import { TI_CENTER_BUTTON } from "../../Constants";

export default function MapStatsAnalysis() {
  const [fillColorLegend, setFillColorLegend] = useState([]);
  const [isVisibleModal, setIsVisibleModal] = useState(false);

  const commonMapProps = {
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      checkStartYear: getLastYear() - 1,
      checkStartMonth: 12,
      checkEndYear: getLastYear(),
      checkEndMonth: 12,
      currentDistrictCode: "",
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (feature, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {
          properties: { pk, name },
        } = feature;
        const code = pk;
        const total = metricObject[code];
        if (total) {
          return `<span class='fontStyle'>${name}</span><br/>
                  무선국 수 : ${numberWithCommas(total)} 개`;
        }
        return `<span class='fontStyle'>${name}</span><br/>
                무선국 수 : 0 개`;
      },
      getLevelFillColor: ({ properties: { pk } }, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const total = metricObject[code];
        if (total) {
          if (total >= 1) {
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (total - 1)) / metricMax
            );
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      cls_code_stats_list: [
        "32",
        "94",
        "44",
        "85",
        "49",
        "92",
        "42",
        "41",
        "21",
        "CMFL",
        "OTHER",
      ],
    },
  };

  const mapProps1 = useMapProps(commonMapProps);
  const mapProps2 = useMapProps(commonMapProps);

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    setGeojsonExtraParams,
    currentDistrictCode,
    setChartAjaxParams,
  } = mapProps1;

  const mapProps2ClickedPolygonGeojsonObjects =
    mapProps2.clickedPolygonGeojsonObjects;

  useStatsAnalysisSyncViewState(mapProps1, mapProps2);

  useEffect(() => {
    const { cls_code_stats_list } = widgetState;
    ////////// ajax new_param 설정////////////
    // 연월 세팅
    const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } =
      geojsonExtraParams;

    window.sidoCode =
      (currentDistrictCode || "").length < 2
        ? ""
        : currentDistrictCode.substr(0, 2);

    let paramStartMonth = "";
    let paramEndMonth = "";

    if (checkStartMonth < 10) {
      paramStartMonth = "0" + checkStartMonth.toString();
    } else {
      paramStartMonth = checkStartMonth.toString();
    }

    if (checkEndMonth < 10) {
      paramEndMonth = "0" + checkEndMonth.toString();
    } else {
      paramEndMonth = checkEndMonth.toString();
    }

    window.searchStart = checkStartYear.toString() + paramStartMonth;
    window.searchEnd = checkEndYear.toString() + paramEndMonth;

    // as-is 의 json 통신을 위한 문자열 만들기
    window.chkString1 = JSON.stringify({
      data: cls_code_stats_list.map((value) => ({ CHK_VALUE: value })),
    });

    window.prm_check = cls_code_stats_list;

    window.new_param =
      "sidoCode=" +
      window.sidoCode +
      "&searchYear=" +
      window.searchStart +
      "&searchYear_bf=" +
      window.searchEnd +
      "&chkString=" +
      window.chkString1;
    ////////// ajax new_param 끝 ////////////
    setChartAjaxParams({
      sidoCode: window.sidoCode,
      searchYear: window.searchStart,
      searchYear_bf: window.searchEnd,
      chkString: window.chkString1,
    });
    ////////// ajax new_param 설정 끝////////////

    if (dataResponseList.length === 2) {
      const metricObject1 = Object.entries(dataResponseList[0]).reduce(
        (acc, [code, stats]) => {
          acc[code] = Object.entries(stats)
            .filter(([cls_code]) => cls_code_stats_list.includes(cls_code))
            .reduce((acc, [cls_code, count]) => acc + count, 0);
          return acc;
        },
        {}
      );
      const metricMax1 = Math.max(...Object.values(metricObject1));

      const newMapDistrictStats1 = [metricObject1, metricMax1];
      if (mapProps1.isChangedMapDistrictStats(newMapDistrictStats1))
        mapProps1.setMapDistrictStats(newMapDistrictStats1);

      const metricObject2 = Object.entries(dataResponseList[1]).reduce(
        (acc, [code, stats]) => {
          acc[code] = Object.entries(stats)
            .filter(([cls_code]) => cls_code_stats_list.includes(cls_code))
            .reduce((acc, [cls_code, count]) => acc + count, 0);
          return acc;
        },
        {}
      );
      const metricMax2 = Math.max(...Object.values(metricObject2));

      const newMapDistrictStats2 = [metricObject2, metricMax2];
      if (mapProps2.isChangedMapDistrictStats(newMapDistrictStats2))
        mapProps2.setMapDistrictStats(newMapDistrictStats2);
    }
  }, [dataResponseList, geojsonExtraParams, widgetState, currentDistrictCode]);

  useEffect(() => {
    setGeojsonExtraParams((prev) => ({
      ...prev,
      currentDistrictCode,
    }));
    mapProps2.setCurrentDistrictCode(currentDistrictCode);
    mapProps2.setGeojsonExtraParams((prev) => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {
        properties: { pk },
      } = firstLayer;
      if ((pk || "").length <= 2) {
        mapProps1.setCurrentDistrictCode(pk);
        mapProps2.setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    if (
      mapProps2ClickedPolygonGeojsonObjects &&
      mapProps2ClickedPolygonGeojsonObjects.length > 0
    ) {
      const firstLayer = mapProps2ClickedPolygonGeojsonObjects[0];
      const {
        properties: { pk },
      } = firstLayer;
      if ((pk || "").length <= 2) {
        mapProps1.setCurrentDistrictCode(pk);
        mapProps2.setCurrentDistrictCode(pk);
      }
    }
  }, [mapProps2ClickedPolygonGeojsonObjects]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()]
          .map((colorIndex) => {
            const boundary = (metricMax / 9) * (colorIndex + 1);
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (boundary - 1)) / metricMax
            );
            const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
            return [colorRgb, boundary];
          })
          .reverse()
      );
    }
  }, [mapDistrictStats]);

  return (
    <>
      <MapPropsProvider value={mapProps1}>
        <MapBase
          isHideControlsOnRightSide={true}
          mapBaseStyle={{
            width: "50%",
            position: "absolute",
            borderRight: "1px solid #000",
          }}
        >
          <WidgetContainer>
            <div>
              <WidgetDistrictSelect
                isShowDistrictLayerFromGeoserver={true}
                onlyLv1={true}
                nationwideZoomAdj={1}
              />
              <WidgetSelectMonthDetail />
              <WidgetClsCodeforStats />
            </div>
          </WidgetContainer>
          <WidgetStatsAnalysisIndicator
            year={geojsonExtraParams.checkStartYear}
            month={geojsonExtraParams.checkStartMonth}
          />
          <RMateChartStatsAnalysis
            disabled={widgetState.cls_code_stats_list.length === 0}
          />
        </MapBase>
      </MapPropsProvider>

      <MapPropsProvider value={mapProps2}>
        <MapBase
          isHideControlsOnLeftSide={true}
          isHideControlsOnRightSide={true}
          isHideWidgetMapType={true}
          isHideWidgetToggleClustering={true}
          isHideWidgetMapLayerTypes={true}
          mapBaseStyle={{ width: "50%", position: "absolute", right: 0 }}
        >
          <WidgetDistrictSelect
            isShowDistrictLayerFromGeoserver={true}
            hidden={true}
            nationwideZoomAdj={1}
          />
          <WidgetStatsAnalysisIndicator
            year={geojsonExtraParams.checkEndYear}
            month={geojsonExtraParams.checkEndMonth}
          />
        </MapBase>

        <WidgetRisingTabs
          titleOnInit={["각 구역에 대한 국종별 무선국 수"]}
          elementForShowListButton={
            document.getElementsByClassName("toolbar-show-list")[1]
          }
        >
          <WidgetStatisticsTable
            fetchUrl={getApiUrl({ type: "type1" })}
            type={"type1"}
            getTitle={(layer) => `각 구역에 대한 국종별 무선국 수 `}
            processor={(objectList) => {
              const rowList = objectList.map((row) => {
                const { cmpr_year } = row;

                const replacedYear = cmpr_year.replace(
                  /(\d{4})(\d{2})/,
                  "$1-$2"
                );
                return { ...row, cmpr_year: replacedYear };
              });
              const columns = [];
              return [columns, rowList];
            }}
            columns={
              // (currentPageData) => (
              [
                {
                  title: "순번",
                  dataIndex: "index",
                  key: "index",
                  width: 80,
                  fixed: "left",
                  // sorter: makeTableSorterFn("index"),
                },
                {
                  title: "지역명",
                  dataIndex: "leg_dnr_nm",
                  key: "leg_dnr_nm",
                  width: 180,
                  fixed: "left",
                  // sorter: makeTableSorterFn("leg_dnr_nm"),
                  // , render: makeRowSpanRender({ columnName: 'leg_dnr_nm', currentPageData})
                },
                {
                  title: "년월",
                  dataIndex: "cmpr_year",
                  key: "cmpr_year",
                  // sorter: makeTableSorterFn("cmpr_year"),
                },
                {
                  title: "합계",
                  dataIndex: "cnt_sum",
                  key: "cnt_sum",
                  // sorter: makeTableSorterFn("cnt_sum"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "기지국",
                  dataIndex: "cnt_32",
                  key: "cnt_32",
                  // sorter: makeTableSorterFn("cnt_32"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "간이무선국",
                  dataIndex: "cnt_94",
                  key: "cnt_94",
                  // sorter: makeTableSorterFn("cnt_94"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "육상이동국",
                  dataIndex: "cnt_44",
                  key: "cnt_44",
                  // sorter: makeTableSorterFn("cnt_44"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "이동중계국",
                  dataIndex: "cnt_85",
                  key: "cnt_85",
                  // sorter: makeTableSorterFn("cnt_85"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "이동국",
                  dataIndex: "cnt_49",
                  key: "cnt_49",
                  // sorter: makeTableSorterFn("cnt_49"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "아마추어국",
                  dataIndex: "cnt_92",
                  key: "cnt_92",
                  // sorter: makeTableSorterFn("cnt_92"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "의무선박국",
                  dataIndex: "cnt_42",
                  key: "cnt_42",
                  // sorter: makeTableSorterFn("cnt_42"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "선박국",
                  dataIndex: "cnt_41",
                  key: "cnt_41",
                  // sorter: makeTableSorterFn("cnt_41"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "고정국",
                  dataIndex: "cnt_21",
                  key: "cnt_21",
                  // sorter: makeTableSorterFn("cnt_21"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "전파응용설비",
                  dataIndex: "cnt_cmfl",
                  key: "cnt_cmfl",
                  // sorter: makeTableSorterFn("cnt_cmfl"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },
                {
                  title: "기타",
                  dataIndex: "cnt_other",
                  key: "cnt_other",
                  // sorter: makeTableSorterFn("cnt_other"),
                  render: (value) =>
                    AlignRightText({ text: value, numberComma: true }),
                },0
              ]
              // )
            }
            horizontalScroll={2400}
          />
        </WidgetRisingTabs>

        <WidgetLegend
          fillColorLegend={fillColorLegend}
          titleColorLegend={"무선국 수"}
          unitColorLegend={"개"}
        />

        <button
          style={CENTER_BUTTON_STYLE}
          onClick={() => {
            if (dataResponseList.length === 2) {
              setIsVisibleModal(true);
            }
          }}
          tabIndex={TI_CENTER_BUTTON}
        >
          <img src={CenterIcon} style={{ width: 90 }} alt={"융합결과 보기"} />
        </button>
        <WidgetStatsAnalysisModal
          visible={isVisibleModal}
          setVisible={setIsVisibleModal}
          currentDistrictCode={currentDistrictCode}
          usingClsCodeList={widgetState.cls_code_stats_list}
          firstData={{
            year: geojsonExtraParams.checkStartYear,
            month: geojsonExtraParams.checkStartMonth,
            dataList: dataResponseList[0],
          }}
          secondData={{
            year: geojsonExtraParams.checkEndYear,
            month: geojsonExtraParams.checkEndMonth,
            dataList: dataResponseList[1],
          }}
        />
      </MapPropsProvider>

      <WidgetToolbar />
    </>
  );
}

const CENTER_BUTTON_WIDTH = 100;
const CENTER_BUTTON_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: CENTER_BUTTON_WIDTH + "px",
  height: CENTER_BUTTON_WIDTH + "px",
  marginLeft: -1 * Math.floor(CENTER_BUTTON_WIDTH / 2) + "px",
  marginTop: -1 * Math.floor(CENTER_BUTTON_WIDTH / 2) + "px",
  textAlign: "center",
  verticalAlign: "middle",
  zIndex: 1,
  cursor: "pointer",
  backgroundColor: "transparent",
  border: "none",
};
